import sponsoredTextOffers from './SponsoredTextOffers';

export default sponsoredTextOffers;
